// RatingApi.js
export const sendRatingMessage = async (payload) => {
    try {
      const response = await fetch("https://xae0-ycmh-cnpt.n7c.xano.io/api:cyRcmRX9/vendors/rate_vendor", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      return response;
    } catch (error) {
      console.error("Error sending rating:", error);
      throw error; // Rethrow error for handling in the calling function
    }
  };
  